import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { PaymentMethodsApi } from "@freightsimple/generated-dashboard-openapi-client/apis/PaymentMethodsApi";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { getConfig } from "@/Apis/getConfig";

export function usePaymentMethodsApi(): PaymentMethodsApi {
  const { accessToken } = useAuthentication();

  return new PaymentMethodsApi(
    new Configuration({ ...getConfig(), accessToken: accessToken }),
  );
}
